import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import ContractFormModal from "./ContractFormModal";

const AddContract = ({ updateParent, presetEmployee }) => {
  const [open, setOpen] = useState(false);
  const history = useHistory();

  return (
    <div className="AddContract">
      <MainButtonComp text="Add Contract" addBtn onClick={() => setOpen(true)} />
      {open && (
        <ContractFormModal
          open={open}
          presetEmployee={presetEmployee}
          onClose={() => setOpen(false)}
          onSaved={contract => {
            updateParent?.();
            // Straight on to the contract, where it is signed.
            if (contract?._id) history.push(`/user/contract/${contract._id}`);
          }}
        />
      )}
    </div>
  );
};

export default AddContract;
